<template>
	<component v-bind:is="item.Url != '' ? 'a' : 'div'"
			   v-bind:href="item.Url != '' ? item.Url : null"
			   v-bind:target="item.Url != '' ? (item.Url.indexOf('/') == 0 ? '_self' : '_blank') : null"
			   v-bind:class="item.Url == '' ? 'no-link' : ''"
			   class="card card-horizontal card-outer card-callout">
		
		<img v-if="item.Image" v-bind:src="item.Image" alt="" />

		<div class="card-content">
			<span class="icon icon-download" v-if="item.UrlExtension == 'PDF'"></span>
			<span class="icon icon-arrow-right has-url" v-else-if="item.Url"></span>

			<p class="meta" v-if="displayDate">
				{{ formatDate(item.Date) }}
			</p>
			<h2 class="card-callout-title">
				{{ item.Title }}
				<template v-if="item.UrlExtension != null && item.UrlExtension != ''">
					&nbsp;[{{ item.UrlExtension }}]
				</template>
			</h2>
			<div v-if="displaySummary"
				 v-html="item.Summary">
			</div>
			<span class="cta-link" v-if="item.UrlExtension == 'PDF'">Download</span>

			<div class="card-tags" v-if="item.AssetType || item.Topics">
				<span v-if="item.AssetType">Type:</span>
				<ul v-if="item.AssetType">
					<li class="accent">{{ item.AssetType }}</li>
				</ul>

				<span v-if="item.Topics">Topics:</span>
				<ul v-if="item.Topics">
					<li class="accent" v-for="topic in item.Topics" v-bind:key="topic">{{ topic }}</li>
				</ul>
			</div>
		</div>
	</component>
</template>

<script>
	import DateFormatService from '../../services/date-format.service';

	export default {
		props: ['item', 'displayDate', 'displaySummary'],
		components: {

		},
		mounted: function () {

		},
		methods: {
			formatDate(date) {
				return DateFormatService.formatDate(date);
			},
        },
    }
</script>